import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import LinkJump from '@gp/components/LinkJump';
import PlatformIcon from '@gp/components/PlatformIcon/PlatformImg';
import { queryJumpable } from '@gp/utils/common';
import { getProjectDetailsPagePath, goToProjectDetailsPageByPath } from '@gp/utils/project';
import classnames from 'classnames';
import React, { useMemo } from 'react';
import { Bubble } from 'tea-component';
// @ts-ignore
import RestrictedContent from '@gp/components/RestrictedContent';
import { PROJECT_DETAIL_STORAGE_KEY } from '@gp/constants/storageKeys';
import { formatMilestoneDateByStatus } from '@gp/utils/milestone';
import { storage } from '@gp/utils/utils';

const GRActionItem: React.FC<any> = (props) => {
  const { data } = props;
  const {
    project_id: projectId,
    project,
    studio,
    cover,
    platform,
    bo,
    pteam,
    stage,
    business_owner,
    gate_review: gateReview,
    next_gate_review: nextGateReview,
    project_auth: projectAuth,
  } = data || {};

  const jumpParams = {
    id: projectId || '',
    name: project,
    tab: 'milestone',
  };

  const url = getProjectDetailsPagePath?.(jumpParams);

  const handleNavigate = (e?: React.MouseEvent) => {
    if (!queryJumpable(e)) return;
    const { milestone_id: milestoneId } = data?.gate_review || {};
    storage.setSessionStorageItem(
      PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_MILESTONE_ID_STORAGE_KEY,
      milestoneId,
    );
    goToProjectDetailsPageByPath(url);
  };

  const boCur = useMemo(() => {
    return bo || business_owner;
  }, [business_owner, bo]);

  const { milestone, date_confirm: dateConfirm, date } = gateReview || {};
  const {
    milestone: nextMilestone,
    date_confirm: nextDateConfirm,
    date: nextDate,
  } = nextGateReview || {};
  const dateFormatted = formatMilestoneDateByStatus(date, dateConfirm) || '-';
  const nextDateFormatted = formatMilestoneDateByStatus(nextDate, nextDateConfirm) || '-';
  const showNextGateReview = !!nextMilestone && !!nextDate;

  const platformCur = useMemo(() => {
    if (Array.isArray(platform)) {
      return platform;
    }
    if (platform && typeof platform === 'string') {
      const arrPlatform = platform?.split(',') || [];
      return arrPlatform;
    }
    return [];
  }, [platform]);

  return (
    <div className="dbg-gr-action-project-left">
      <div className="dbg-gr-action-project-info">
        <LinkJump
          className="dbg-cursor-pointer"
          stopPropagation={false}
          url={url}
          onClick={handleNavigate}
        >
          <div className="dbg-gr-action-project-avatar">
            <GeneralImageNew
              className="dbg-gr-action-items-project-context__project-icon"
              domain="game"
              width={32}
              height={32}
              src={cover || '-'}
            />
          </div>
        </LinkJump>
        <LinkJump
          className="dbg-cursor-pointer"
          stopPropagation={false}
          url={url}
          onClick={handleNavigate}
        >
          <EllipsisTextBubble
            className="dbg-gr-action-items-project-context__project-name"
            text={project || '-'}
            ellipsisLineClamp={2}
            customBubbleContent={project}
          />
        </LinkJump>
        <div className="dbg-gr-action-project-icons">
          <PlatformIcon platform={platformCur?.join(',') || ''} />
        </div>
        <div className="dbg-gr-action-project-tag">P-team: {pteam || '-'}</div>
        <div className="dbg-gr-action-project-tag">BO: {boCur || '-'}</div>
        <div className="dbg-gr-action-project-tag">Studio: {studio || '-'}</div>

        {projectAuth === false ? (
          <div className="dbg-gr-action-project-tag dbg-gr-action-project-gate-review">
            <div className="dbg-gr-action-project-tag-title">Review Type: </div>
            <div className="dbg-gr-action-project-tag-restricted">
              <RestrictedContent />
            </div>
          </div>
        ) : (
          <Bubble
            className={classnames('dbg-bubble-max-width')}
            dark
            arrowPointAtCenter
            placement="top"
            content={
              <div className="dbg-initial-line-height dbg-gr-action-items-gate-review-bubble-content">
                <div>
                  Current Review: {milestone} ({dateFormatted})
                </div>
                <div style={{ marginTop: 6 }}>
                  Next Review:{' '}
                  {!showNextGateReview ? `-` : `${nextMilestone} (${nextDateFormatted})`}
                </div>
              </div>
            }
          >
            <div className="dbg-gr-action-project-tag">
              Review Type:{' '}
              <span className="dbg-common-black-text">
                {milestone || '-'} {dateFormatted}
              </span>
            </div>
          </Bubble>
        )}
      </div>
    </div>
  );
};

export default GRActionItem;
